import { Vec2 } from 'planck-js'
import type { IVec2 } from '../../../engine/messageWriter'
import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { rando } from '../../../lib/rando-sidecar'
import { golfPucks } from '../actors/golfPucks-sidecar'
import { golfMessagePuckMove } from '../messages/golfMessagePuckMove-sidecar'
import { golfPhysics } from './golfPhysics-sidecar'
import { golfPhysicsDefs } from './golfPhysicsDefs-sidecar'

let _frame = 0
let _frameDelay = 20
export function getFrame() {
  return _frame
}

export function create() {
  let x = 100
  let y = 100
  let w = 600
  let h = 400

  let offset = 80
  golfPucks.create(x + offset, y + offset)
  golfPucks.create(x + w - offset, y + h - offset)

  let wh = 50
  let ws = golfPhysics.worldScale
  golfPhysics.createBodyBox(x + w / 2, y + wh / 2, w, wh, {
    fixDef: golfPhysicsDefs.borderPhysicsDef.fix,
    bodyDef: golfPhysicsDefs.borderPhysicsDef.body,
    dynamic: false,
  })
  golfPhysics.createBodyBox(x + w / 2, y + h - wh / 2, w, wh, {
    fixDef: golfPhysicsDefs.borderPhysicsDef.fix,
    bodyDef: golfPhysicsDefs.borderPhysicsDef.body,
    dynamic: false,
  })

  golfPhysics.createBodyBox(x + wh / 2, y + h / 2, wh, h, {
    fixDef: golfPhysicsDefs.borderPhysicsDef.fix,
    bodyDef: golfPhysicsDefs.borderPhysicsDef.body,
    dynamic: false,
  })
  golfPhysics.createBodyBox(x - wh / 2 + w, y + h / 2, wh, h, {
    fixDef: golfPhysicsDefs.borderPhysicsDef.fix,
    bodyDef: golfPhysicsDefs.borderPhysicsDef.body,
    dynamic: false,
  })

  knock()

  // golfPhysics.createBodyBox(x + w, y, w, h, {
  //   fixDef: golfPhysicsDefs.shipPartPhysicsDef.fix,
  //   bodyDef: golfPhysicsDefs.shipPartPhysicsDef.body,
  //   dynamic: false,
  // })
  // golfPhysics.createBodyBox(x, y, w, h, {
  //   fixDef: golfPhysicsDefs.shipPartPhysicsDef.fix,
  //   bodyDef: golfPhysicsDefs.shipPartPhysicsDef.body,
  //   dynamic: false,
  // })
}

export function update() {
  _frame++

  let dead: IPhysicsFutureEvent[] = []
  l.forEach(_futureEvents, (c) => {
    if (_frame >= c.frame) {
      let p = golfPucks.findByIdSafe(c.puckId)
      if (p) {
        if (c.type === EPhysicsFutureEventType.Hit) {
          p.body.applyForceToCenter(Vec2(c.force), true)
        }
        if (c.type === EPhysicsFutureEventType.Pos) {
          p.body.setPosition(Vec2(c.pos))
          p.body.setLinearVelocity(Vec2(c.vel))
        }
      }
      dead.push(c)
    }
  })
  l.forEach(dead, (c) => {
    l.remove(_futureEvents, c)
  })

  golfPhysics.updateAll()
}

export function knock() {
  l.forEach(golfPucks.getAll(), (c) => {
    let x = rando.fs(2000)
    let y = rando.fs(2000)

    golfMessagePuckMove.sendMessageAndImmediatelyExecute({
      pieceId: c.id,
      frame: _frame + _frameDelay,
      force: { x, y },
    })

    // console.log('knock2', x, y)
  })
}

export enum EPhysicsFutureEventType {
  Pos = 1,
  Hit,
}
export interface IPhysicsFutureEvent {
  puckId: number
  type: EPhysicsFutureEventType
  frame: number
  force: IVec2
  pos: IVec2
  vel: IVec2
}
let _futureEvents: IPhysicsFutureEvent[] = []
export function addFutureEvent(fh: IPhysicsFutureEvent) {
  _futureEvents.push(fh)
}

export function setFrame(fr: number) {
  _frame = fr
}
